import Pages from "pages/pages";
import LoadingProvider from "providers/loading";
import { FunctionComponent } from "react";

interface AppProps {}

const App: FunctionComponent<AppProps> = () => {
  return (
    <LoadingProvider>
      <Pages />
    </LoadingProvider>
  );
};

export default App;
